export const userModel = {
  uid: "",
  email: "",
  password: "",
  re_password: "",
  first_name: "",
  last_name: "",
  tel: "",
  agent_name: "",
  is_admin: false,
}
